// hooks/engagement/engagementsApi.js

import apiService from '../../services/api';

export const engagementsApi = {

  listEngagements: async ({ bid_status, engagement_type, industry, search, limit = 50, offset = 0 } = {}) => {
    return apiService.get('/engagements', { bid_status, engagement_type, industry, search, limit, offset });
  },

  getEngagement: async (engagementId) => {
    return apiService.get(`/engagements/${engagementId}`);
  },

  /**
   * Create a new engagement.
   * Expects payload already in snake_case from formDataToPayload().
   */
  createEngagement: async (payload) => {
    return apiService.post('/engagements', payload);
  },

  /**
   * Update engagement metadata.
   * Expects updates already in snake_case from formDataToPayload().
   */
  updateEngagement: async (engagementId, updates) => {
    console.log('📤 PATCH /engagements/' + engagementId, JSON.stringify(updates));
    const response = await apiService.patch(`/engagements/${engagementId}`, updates);
    console.log('📥 PATCH response:', JSON.stringify(response));
    return response;
  },

  deleteEngagement: async (engagementId) => {
    return apiService.delete(`/engagements/${engagementId}`);
  },

  syncActuals: async (engagementId) => {
    return apiService.post(`/engagements/${engagementId}/sync-actuals`, {});
  },

  getWonEngagements: async ({
    engagement_type, industry, search, time_period,
    start_date, end_date, exclude_unknown, limit = 20
  } = {}) => {
    return apiService.get('/engagements/reference/won', {
      engagement_type, industry, search, time_period,
      start_date, end_date, exclude_unknown, limit,
    });
  },
};

export const qbCustomersApi = {
  listQBCustomers: async ({ search, limit = 100 } = {}) => {
    return apiService.get('/api/qb/customers', { search, limit });
  },

  getQBCustomer: async (customerId) => {
    return apiService.get(`/api/qb/customers/${customerId}`);
  },
};

export default engagementsApi;

export const syncAllEngagementActuals = async () => {
  return apiService.post('/engagements/sync-all-actuals');
};